// extracted by mini-css-extract-plugin
module.exports = {"shareDropdownIcon":"ShareDropdownSection_shareDropdownIcon__2BFJj","shareRow":"ShareDropdownSection_shareRow__3oj69","shareLabel":"ShareDropdownSection_shareLabel__gCBZF"};